import { useIntl } from 'react-intl'
import { NumberInput } from 'ui'
import { SettingsProps } from '../../../hooks/useGenericComponent'
import { messages } from './messages'

export function PercentualEditor(props: SettingsProps) {
  const { state } = props

  const { $t } = useIntl()

  return (
    <NumberInput
      name="value"
      state={state}
      aria-label={$t(messages.editor.ariaLabel)}
      helpText={$t(messages.editor.helpText)}
      suffix="%"
    />
  )
}
